module.exports = __webpack_public_path__ + "img/partseven_pic1.c3bb81cb.png";